import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses HttpOnly cookies — tokens are never accessible to JavaScript.
const api = axios.create({ baseURL: API, withCredentials: true });

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const status = err.response?.status;
    const url = original?.url || "";
    const isAuthPath = ["/auth/login", "/auth/refresh", "/auth/logout"].some((p) => url.includes(p));

    if (status === 401 && original && !original._retry && !isAuthPath) {
      original._retry = true;
      if (String(err.response?.data?.detail || "").includes("inactivity")) {
        sessionStorage.setItem("idle_logout", "1");
        if (window.location.pathname !== "/login") window.location.href = "/login";
        return Promise.reject(err);
      }
      try {
        // Single shared refresh so concurrent 401s trigger only one refresh call
        refreshPromise =
          refreshPromise || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch {
        refreshPromise = null;
        // For the boot-time session check (/auth/me) rely on AuthContext +
        // ProtectedRoute to soft-navigate to /login — a hard redirect here
        // would wipe the Router state that preserves the intended deep link.
        const isBootCheck = url.includes("/auth/me");
        if (!isBootCheck && window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
